import { CaseAssistClient, } from "coveo.analytics/dist/browser.mjs";
import { getOrganizationEndpoint } from '../platform-client.js';
import { BaseAnalyticsProvider } from './base-analytics.js';
import { wrapAnalyticsClientSendEventHook, wrapPreprocessRequest, } from './coveo-analytics-utils.js';
export class CaseAssistAnalyticsProvider extends BaseAnalyticsProvider {
    getSearchUID() {
        return this.state.documentSuggestion?.status.lastResponseId ?? '';
    }
}
export const configureCaseAssistAnalytics = ({ logger, getState, analyticsClientMiddleware = (_, p) => p, preprocessRequest, provider = new CaseAssistAnalyticsProvider(getState), }) => {
    const state = getState();
    const token = state.configuration.accessToken;
    const endpoint = state.configuration.analytics.apiBaseUrl ??
        getOrganizationEndpoint(state.configuration.organizationId, state.configuration.environment, 'analytics');
    const runtimeEnvironment = state.configuration.analytics.runtimeEnvironment;
    const enableAnalytics = state.configuration.analytics.enabled;
    const client = new CaseAssistClient({
        enableAnalytics,
        token,
        endpoint,
        runtimeEnvironment,
        preprocessRequest: wrapPreprocessRequest(logger, preprocessRequest),
        beforeSendHooks: [
            wrapAnalyticsClientSendEventHook(logger, analyticsClientMiddleware),
            (type, payload) => {
                logger.info({
                    ...payload,
                    type,
                    endpoint,
                    token,
                }, 'Analytics request');
                return payload;
            },
        ],
    }, provider);
    if (!enableAnalytics) {
        client.disable();
    }
    return client;
};
